import CircularProgress from '@material-ui/core/CircularProgress';
import {withStyles} from '@material-ui/core/styles';
import React from "react";


function PageLoader(props) {
  const {classes} = props;

  return (
    <div className={classes.loader}>
      <CircularProgress value={1}/>
    </div>
  )
}

const styles = {
  loader: {
    flexGrow: 1,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
};

export default withStyles(styles)(PageLoader);


// WEBPACK FOOTER //
// ./src/parts/PageLoader.js